import * as React from "react"
import { navigate } from "gatsby"
import styled from "styled-components"
import { compose, withStateHandlers, StateHandlerMap } from "recompose"
import { Variables } from "@life-without-barriers/react-components"
import { sendEvent } from "@life-without-barriers/utilities"

const { muli } = Variables

const placeholderStyles = `
  color: #9B9B9B;
  font-family: ${muli};
`

const StyledInputWrapper = styled.div`
  top: 50%;
  transform: translateY(-50%);
`

const StyledInput = styled.input`
  ::placeholder {
    ${placeholderStyles};
  }

  /* IE hack to hide clear 'x' to the right of input */
  &::-ms-clear {
    height: 0;
    width: 0;
  }
`

const MobileSearchBox = (props: Props) => {
  const passRefToProps = props.fetchChildRef
    ? props.fetchChildRef
    : () => {
        return
      }

  return (
    <StyledInputWrapper className="relative">
      <StyledInput
        className="pa3 pr4 w-100 ba b-lwb-grey-dark br2 outline-0 muli bg-white lh-title t-mobile-search-input"
        type="search"
        ref={(input) => {
          passRefToProps(input)
        }}
        value={props.query}
        placeholder="Search the guide"
        onChange={(event) => props.setQuery(event.target.value)}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            props.onSearch(props.query)
          }
        }}
      />
    </StyledInputWrapper>
  )
}

export interface SearchBoxProps {
  onSearch: (query: string) => void
  initialQuery?: string
  hideButton?: boolean
  fetchChildRef?: (node: unknown) => void
}

export const onSearch = (queryValue: string) => {
  sendEvent("Home page", "Click", "Search button")
  void navigate(`/foster-care/support/carer-guide/search?query=${queryValue}`)
}

interface State {
  query: string
}

interface StateHandlers extends StateHandlerMap<State> {
  setQuery: (query: string) => State
}

type Props = SearchBoxProps & State & StateHandlers

const initialState = (props: SearchBoxProps) => ({
  query: props.initialQuery || ""
})

const stateHandlers = {
  setQuery: () => (query: string) => ({ query })
}

export default compose<Props, SearchBoxProps>(
  withStateHandlers(initialState, stateHandlers)
)(MobileSearchBox)
